import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-six',
  templateUrl: './home-thirty-six.component.html',
  styleUrls: ['./home-thirty-six.component.scss']
})
export class HomeThirtySixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
